import 'bootstrap/dist/css/bootstrap.min.css';
import { json, useNavigate} from 'react-router-dom'
import React, { useState,useEffect } from 'react';
import Loading from '../Components/Loading'
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  button,
  MDBInput,
}
from 'mdb-react-ui-kit';
import sp from '../Styles/Signup.css'
////////functional component //////////////////////////////////
function Login() {
    
  //loading
  const [loading,setLoading] = useState(false);

    /// navigation////////////////////////////////////////////
    const navigate = useNavigate();
    
    ///runs when page is rendered////////////////////////////
    useEffect(() => {
      const auth = localStorage.getItem('user');
      if(auth)
      {
          navigate('/')
          window.location.reload(false) 
      }
    });

    //Login on change variables////////////////////////
    //registration on change variables////////////////////////
    const [name,setname] = useState("");
    const [email,setemail] = useState("");
    const [password,setpass] = useState("");
    //ON LOGIN CLICK BUTTON//////////////////////////////
    const handleLogin= async()=>
    {
      ///loadddiiiiiiiiinggggggggggggggggggggg/////////////
      setLoading(true);
      let resultl = await fetch("https://bechnaabackend.onrender.com/login",
      {
        method:'post',
        body:JSON.stringify({email,password}),
        headers:{'Content-Type':'application/json'}
      })
      resultl =  await resultl.json();
      console.warn(resultl);
      if(resultl.name)
      {
          localStorage.setItem("user",JSON.stringify(resultl));
          navigate('/');
          window.location.reload(false);
      }
      else
      {
        alert("PLEASE ENTER CORRECT DETAILS");
      }
      ///loadddiiiiiiiiinggggggggggggggggggggg/////////////
      setLoading(false);
    }

    

    ///ON REGISTER CLICK BUTTON //////////////////////////////////
    const collectdata =async()=>
    {
      setLoading(true);

        let result = await fetch('https://bechnaabackend.onrender.com/signup',{
            method:'post',
            body:JSON.stringify({name,email,password}),
            headers:{ 'Content-Type': 'application/json'}
        })
           
            if(result.status==200)
            {
              let result1 =  await result.json();
              localStorage.setItem("user",JSON.stringify(result1));
              navigate('/');
              window.location.reload(false);
            }
            else
            {
              alert("EMAIL ALREADY EXISTS");
            }
      setLoading(false);
             
    }

  //login and register tab change //////////////////////////////
  const [justifyActive, setJustifyActive] = useState('tab1');
  const handleJustifyClick = (value) => {
    //checking if the value i.e tab1, tab2 
    if (value === justifyActive) {
      return;
    }
    else
    {
      setJustifyActive(value);
    }
  };

  return (
    <>
    {loading === true ? (<Loading/>) : (<MDBContainer id = 'loginContainer' className="p-1 my-5 d-flex flex-column w-50">
      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <MDBTabsLink id='logintab' onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'}>
            Login
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink  id='logintab' onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'}>
            Register
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>
        {/* LOGIN TAB CONTENTS  */}
        <MDBTabsPane show={justifyActive === 'tab1'}>
          <label>Email address</label>
          <MDBInput wrapperClass='mb-1' onChange={(e)=>setemail(e.target.value)} id='form1e' type='email'/>
          <label>Password</label>
          <MDBInput wrapperClass='mb-1'  onChange={(e)=> setpass(e.target.value)} id='form1p' type='password'/>
          <p></p>
          <button className="mb-1 w-100" onClick={handleLogin}  id='buttonL'>Sign in</button>
        </MDBTabsPane >
         {/* REGISTER TAB CONTENTS  */}
        <MDBTabsPane  show={justifyActive === 'tab2'}>
          <label>Name</label>
          <MDBInput wrapperClass='mb-1'  onChange={(e)=>setname(e.target.value)} id='form2n' type='text'  required/>
          <label>VIT Email</label>
          <MDBInput wrapperClass='mb-1'  onChange={(e)=>setemail(e.target.value)} id='form2e' type='email'  required/>
          <label>Password</label>
          <MDBInput wrapperClass='mb-1'  onChange={(e)=>setpass(e.target.value)}  id='form2p' type='password'  required/>
          <button className="mb-1 w-100" id='buttonL' onClick={collectdata}>Sign up</button>
         
        </MDBTabsPane>
        
      </MDBTabsContent>
    </MDBContainer>)}
    </>
  );
}
export default Login;